import { Camera, Video } from "lucide-react";

function SocialLinks() {
  return (
    <section className="bg-green-50 py-16 px-6 md:px-16 border-t border-green-100">

      <div className="text-center mb-10">
        <span className="text-green-700 font-extrabold text-sm uppercase tracking-widest">Connect With Us</span>
        <h2 className="text-3xl md:text-5xl font-black text-neutral-900 mt-1">
          Follow Our Journey
        </h2>
      </div>

      {/* FIXED: Changed to grid, set to 3 columns on desktop, and expanded the max-width container */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto w-full">

        {/* Instagram Link Card */}
        <a
          href="https://www.instagram.com/goodlifeashram1969?igsh=aGlweTh2bDdjdm5m"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white shadow-xl rounded-3xl px-12 py-8 text-center hover:scale-105 transition duration-300 flex flex-col items-center justify-center border border-green-100 group"
        >
          <div className="p-4 bg-pink-50 rounded-full text-pink-600 transition duration-300 group-hover:bg-gradient-to-tr group-hover:from-[#f9ce34] group-hover:via-[#ee2a7b] group-hover:to-[#6228d7] group-hover:text-white">
            <Camera className="w-10 h-10" />
          </div>
          <h3 className="text-2xl font-black text-neutral-900 mt-4">
            Instagram
          </h3>
          <p className="text-neutral-900 text-sm font-bold mt-1">
            @goodlifeashram1969
          </p>
        </a>
        
        {/* Facebook Link Card */}
        <a
          href="https://www.facebook.com/profile.php?id=100057197119885"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white shadow-xl rounded-3xl px-12 py-8 text-center hover:scale-105 transition duration-300 flex flex-col items-center justify-center border border-green-100 group"
        >
          <div className="p-4 bg-blue-50 text-blue-600 rounded-full transition duration-300 group-hover:bg-[#1877F2] group-hover:text-white">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="40" 
              height="40" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              className="w-10 h-10"
            >
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
            </svg>
          </div>
          <h3 className="text-2xl font-black text-neutral-900 mt-4">
            Facebook
          </h3>
          <p className="text-neutral-900 text-sm font-bold mt-1">
            Universal Good Life Ashram
          </p>
        </a>

        {/* YouTube Link Card */}
        <a
          href="https://youtube.com/@universalgoodlifeashram?si=l5E"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white shadow-xl rounded-3xl px-12 py-8 text-center hover:scale-105 transition duration-300 flex flex-col items-center justify-center border border-green-100 group"
        >
          <div className="p-4 bg-red-50 text-red-600 rounded-full transition duration-300 group-hover:bg-red-600 group-hover:text-white">
            <Video className="w-10 h-10" />
          </div>
          <h3 className="text-2xl font-black text-neutral-900 mt-4">
            YouTube
          </h3>
          <p className="text-neutral-900 text-sm font-bold mt-1">
            @universalgoodlifeashram
          </p>
        </a>

      </div>

    </section>
  );
}

export default SocialLinks;